import FileLineChart from './FileLineChart.vue'

export default FileLineChart

